import { getCurrentLanguage, normalizeLanguage } from '../i18n';

export const NOTIFICATION_ROUTE_KEYWORDS = [
  {
    key: 'mutantBox',
    type: 'NAVIGATE',
    path: '/mutant-box',
    keywords: ['inspirar al mundo', 'descubrimiento', 'mutante', 'portal', 'caja mutante', 'mutant box', 'mutation', 'signal', 'new signal']
  },
  {
    key: 'gallery',
    type: 'NAVIGATE',
    path: '/profile/gallery',
    keywords: ['galeria', 'galeria', 'gallery', 'image', 'images', 'photo', 'photos', 'picture', 'pictures', 'fotos']
  },
  {
    key: 'hyperstition',
    type: 'NAVIGATE',
    path: '/hiperstision',
    keywords: ['hiperstision', 'hipersticion', 'hipersticion', 'hyperstition']
  },
  {
    key: 'questionnaire',
    type: 'NAVIGATE',
    path: '/questionnaire',
    keywords: ['cuestionario', 'questionnaire', 'survey']
  },
  {
    key: 'qoph',
    type: 'NAVIGATE',
    path: '/qoph',
    keywords: ['qoph', 'oraculo', 'oracle']
  },
  {
    key: 'network',
    type: 'NAVIGATE',
    path: '/network',
    keywords: ['red', 'red q', 'conexion', 'conexiones', 'connection', 'connections', 'network', 'group', 'groups', 'nodo', 'nodos', 'seguidor']
  },
  {
    key: 'tasks',
    type: 'CREATE_TASK',
    path: '/tareas',
    payload: {
      es: 'Revisar mi nueva tarea.',
      en: 'Review my new task.'
    },
    keywords: ['tarea', 'tareas', 'meta', 'pendiente', 'pendientes', 'rutina', 'mision', 'task', 'tasks', 'pending', 'todo', 'to-do']
  },
  {
    key: 'places',
    type: 'NAVIGATE',
    path: '/lugares',
    keywords: ['lugar', 'lugares', 'place', 'places', 'location', 'locations', 'ubicacion', 'ubicaciones', 'sitio', 'sitios']
  },
  {
    key: 'consciousness',
    type: 'NAVIGATE',
    path: '/conciencia',
    keywords: ['conciencia', 'consciousness', 'reflection', 'awareness', 'voz', 'hablar', 'microfono', 'pensamiento', 'reflexion', 'conectar']
  },
  {
    key: 'profile',
    type: 'NAVIGATE',
    path: '/profile',
    keywords: ['perfil', 'profile', 'identity', 'resumen', 'estadistica', 'nivel', 'estado', 'account']
  }
];

const ACTION_COPY = {
  es: {
    mutantBox: { title: 'Abrir Caja Mutante', description: 'Explora el portal y genera nuevas mutaciones.' },
    gallery: { title: 'Abrir Galeria', description: 'Revisa tus imagenes y recuerdos visuales.' },
    hyperstition: { title: 'Abrir Hiperstision', description: 'Entra en el registro narrativo de hiperstision.' },
    questionnaire: { title: 'Iniciar Cuestionario', description: 'Continua el cuestionario de conciencia.' },
    qoph: { title: 'Abrir Qoph', description: 'Consulta el oraculo personal de Qproject.' },
    network: { title: 'Ver Red Q', description: 'Revisa tus hilos de conexi\u00f3n.' },
    tasks: { title: 'Ver Tareas', description: 'Ir al panel de tareas pendientes.' },
    places: { title: 'Abrir Lugares', description: 'Revisa tus lugares guardados.' },
    consciousness: { title: 'Abrir Conciencia', description: 'Inicia una nueva sesi\u00f3n de volcado de pensamientos.' },
    profile: { title: 'Ver Perfil', description: 'Accede a tu resumen y estado actual.' }
  },
  en: {
    mutantBox: { title: 'Open Mutant Box', description: 'Explore the portal and generate new mutations.' },
    gallery: { title: 'Open Gallery', description: 'Review your images and visual memories.' },
    hyperstition: { title: 'Open Hyperstition', description: 'Enter the hyperstition narrative log.' },
    questionnaire: { title: 'Start Questionnaire', description: 'Continue the consciousness questionnaire.' },
    qoph: { title: 'Open Qoph', description: 'Consult Qproject\'s personal oracle.' },
    network: { title: 'View Q Network', description: 'Review your connection threads.' },
    tasks: { title: 'View Tasks', description: 'Go to your pending tasks panel.' },
    places: { title: 'Open Places', description: 'Review your saved places.' },
    consciousness: { title: 'Open Consciousness', description: 'Start a new thought-dump session.' },
    profile: { title: 'View Profile', description: 'Open your summary and current state.' }
  }
};

export function normalizeTextForIntent(text = '') {
  return String(text)
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function includesKeyword(normalizedText, keyword) {
  const normalizedKeyword = normalizeTextForIntent(keyword);
  if (!normalizedKeyword) return false;
  return ` ${normalizedText} `.includes(` ${normalizedKeyword} `);
}

export function includesAny(normalizedText, keywords = []) {
  return keywords.some((keyword) => includesKeyword(normalizedText, keyword));
}

function buildAction(config, lang) {
  const normalizedLang = normalizeLanguage(lang);
  const copy = ACTION_COPY[normalizedLang]?.[config.key] || ACTION_COPY.es[config.key];
  const action = {
    type: config.type,
    path: config.path,
    title: copy.title,
    description: copy.description
  };

  if (config.payload) {
    action.payload = config.payload[normalizedLang] || config.payload.es;
  }

  return action;
}

export function analyzeNotification(message, lang = getCurrentLanguage()) {
  if (!message || typeof message !== 'string') return null;

  const text = normalizeTextForIntent(message);
  if (!text) return null;

  const match = NOTIFICATION_ROUTE_KEYWORDS.find((config) => includesAny(text, config.keywords));
  return match ? buildAction(match, lang) : null;
}
